import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";

export const Route = createFileRoute("/painel-iptv/")({
  head: () => ({
    meta: [
      { title: "Painel IPTV - A Melhor Estrutura para Revendedores | P2 PRO" },
      { name: "description", content: "Explore as soluções de Painel IPTV da P2 PRO. Painéis automáticos, white label e pós-pago com estabilidade 4K e suporte 24h. Comece sua revenda profissional hoje." },
      { name: "keywords", content: "painel iptv, sistema revenda iptv, painel de controle iptv, gerenciar clientes iptv" },
    ],
  }),
  component: () => (
    <SEOPage
      heroImage="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=1200"
      showTestimonials={true}
      category="Produtos"
      title="PAINEL IPTV: O CENTRO DE COMANDO DA SUA REVENDA"
      subtitle="Descubra a tecnologia que permite gerenciar milhares de clientes com simplicidade e eficiência absoluta."
      introParagraphs={[
        "O Painel IPTV é a ferramenta central para qualquer pessoa que deseja ingressar ou profissionalizar-se no mercado de entretenimento digital. Ele funciona como uma ponte inteligente entre nossos servidores de alta performance e os dispositivos dos seus clientes, permitindo que você tenha controle total sobre cada acesso vendido.",
        "Na P2 PRO, oferecemos diferentes modalidades de painel para atender desde o revendedor iniciante até grandes distribuidores que desejam ter sua própria marca (White Label) ou automatizar 100% de suas vendas.",
        "Nossa plataforma é reconhecida por ser extremamente leve, intuitiva e segura, garantindo que você gaste menos tempo com suporte técnico e mais tempo focado em estratégias de crescimento e faturamento."
      ]}
      benefits={[
        {
          title: "Interface Intuitiva",
          description: "Menus organizados e simples, pensados para quem não tem conhecimentos técnicos avançados.",
        },
        {
          title: "Gestão de Planos",
          description: "Crie diferentes tipos de pacotes (Completo, Esportes, Adultos) com apenas alguns cliques.",
        },
        {
          title: "Monitoramento Ativo",
          description: "Saiba exatamente quem está assistindo e a qualidade da conexão de cada usuário em tempo real.",
        }
      ]}
      howItWorks={[
        { title: "Pós-Pago", description: "Ideal para quem busca flexibilidade financeira e créditos sob demanda." },
        { title: "Automático", description: "Perfeito para quem deseja vender 24h por dia sem precisar estar online." },
        { title: "White Label", description: "A solução definitiva para quem deseja ter sua própria marca de streaming." },
        { title: "Sub-revenda", description: "Expanda seu negócio criando sua própria rede de revendedores parceiros." }
      ]}
      diferenciais={[
        { title: "Segurança de Dados", description: "Proteção total das informações dos seus clientes e do seu saldo de créditos." },
        { title: "Servidores Tier 3", description: "Hospedagem em data centers de nível mundial para latência zero no painel." },
        { title: "Suporte Especialista", description: "Time técnico à disposição para tirar dúvidas e realizar configurações avançadas." }
      ]}
      faq={[
        {
          question: "Como escolher o melhor painel para mim?",
          answer: "Depende do seu objetivo. Se está começando, o pós-pago é excelente. Se já tem volume, a automação é o caminho."
        },
        {
          question: "O painel funciona no celular?",
          answer: "Sim, nossa interface é totalmente responsiva e funciona perfeitamente em navegadores mobile."
        },
        {
          question: "Posso testar o painel antes de comprar?",
          answer: "Sim! Oferecemos uma demonstração gratuita do painel para que você conheça todas as funcionalidades."
        }
      ]}
      breadcrumbs={[
        { label: "Painel IPTV", href: "/painel-iptv" }
      ]}
      relatedArticles={[
        { title: "Painel IPTV Pós Pago", href: "/painel-iptv/pos-pago" },
        { title: "Melhor Painel IPTV", href: "/painel-iptv/melhor" },
        { title: "Franquia IPTV", href: "/painel-iptv/franquia" }
      ]}
    />
  ),
});
